import {
  GeneratedDocument,
  GeneratedDocumentStatus,
  GeneratedDocumentType,
} from './generateddocuments/generatedDocumentsApiTypes';

// eslint-disable-next-line import/prefer-default-export
export const mockExportReportResponse: GeneratedDocument = {
  id: 1,
  type: GeneratedDocumentType.LISTING_REPORT_EXPORT,
  status: GeneratedDocumentStatus.CREATED,
  title: 'Allegro All offers 14.04.2026 15-04-00',
  errorMessage: null,
  createdAt: '2026-04-14T15:04:00',
  completedAt: null,
  url: null,
};
